<div class="container-md px-3 px-md-0 mt-3 mt-md-0">
  <ng-container *ngIf="vm$ | async as vm">

    <!-- Flow Situation Section -->
    <div class="mt-2 card border-0">
      <app-flow-situation-card
        [user]="vm.user"
        [bmi]="vm.bmi"
        [weightChangePercentage]="vm.weightChangePercentage"
        [timeSnap]="vm.timeSnap"
        [scoreDetails]="vm.scoreDetails"
        [latestSubmissionDate]="vm.latestSubmissionDetails?.createdAt"
      ></app-flow-situation-card>
    </div>

    <!-- NUtritional Goals Section -->
    <div class="mt-2 card box">
      <app-nutrition-goals
        [user]="vm.user"
        [bmi]="vm.bmi"
        [timeSnap]="vm.timeSnap"
        [weightChangePercentage]="vm.weightChangePercentage"
      ></app-nutrition-goals>
      <div class="mb-3 text-center">
        <a href="/faq#gewicht" target="_blank" rel="noopener" class="btn-link link-small">
          {{ 'dashboard.links.gewicht' | translate }}
        </a>
      </div>
    </div>

    <!-- Weight Chart Section -->
    <div class="chart card box mt-2">
      <h3 class="m-0 mt-3 text-center">
        {{ 'dashboard.weight_chart.headline' | translate }}
      </h3>
      <div *ngIf="vm.timeSnap" class="text-center text-muted link-small">
        <em>
          {{ 'fast_lane.webk.date' | translate }}
          {{ vm.timeSnap.timestamp | date: 'dd MMMM yyyy' }}
        </em>
      </div>
      <a
        href="/faq#gewicht"
        target="_blank"
        rel="noopener"
        class="mb-3 btn-link text-center link-small"
      >
        {{ 'dashboard.links.calculation' | translate }}
      </a>

      <app-weight-change-analysis
        [weightChangePercentage]="vm.weightChangePercentage"
        [bmi]="vm.bmi"
      ></app-weight-change-analysis>

      <app-date-picker [date]="vm.date" (dateChange)="onDateChange($event)"></app-date-picker>
      <app-weight-chart [data]="weightData$ | async" [date]="vm.date"></app-weight-chart>

      <div class="mb-3 text-center">
        <a href="/faq#gewicht" target="_blank" rel="noopener" class="btn-link link-small">
          {{ 'dashboard.links.gewicht' | translate }}
        </a>
      </div>
    </div>

    <!-- Basic Webk Chart Section -->
    <div class="chart card box mt-2">
      <h3 class="m-0 mt-3 text-center">
        {{ 'dashboard.survey_chart' | translate }}
      </h3>

      <div *ngIf="vm.latestSubmissionDetails" class="text-center text-muted link-small">
        <em>
          {{ 'fast_lane.webk.date' | translate }}
          {{ vm.latestSubmissionDetails.createdAt | date: 'dd MMMM yyyy' }}
        </em>
      </div>

      <a
        href="/faq#beschwerden"
        target="_blank"
        rel="noopener"
        class="mb-3 btn-link text-center link-small"
      >
        {{ 'dashboard.links.calculation' | translate }}
      </a>

      <app-survey-change-analysis
        [submission]="vm.latestSubmissionDetails"
        [visibleSubjects]="visibleSubjects"
      ></app-survey-change-analysis>

      <div #webkSection>
        <app-date-picker [date]="vm.date" (dateChange)="onDateChange($event)"></app-date-picker>
      </div>

      <app-basic-webk-chart
        [rawData]="basicWebkData$ | async"
        [date]="vm.date"
        (visibleChange)="onVisibleChange($event)"
      ></app-basic-webk-chart>

      <div class="m-3 px-3 text-center text-muted link-small">
        <em>
          {{ 'dashboard.survey_analysis.tipp' | translate }}
        </em>
      </div>
    </div>

    <div class="card box mt-2">
      <app-protein-intake
        [bmi]="vm.bmi"
        [weight]="vm.timeSnap?.weight"
        [height]="vm.user?.coreData?.bodySizeInCm"
      ></app-protein-intake>
    </div>

    <div class="card box mt-2 mb-5">
      <app-other-nutrition-tips></app-other-nutrition-tips>
    </div>

    <div class="card box mt-2 mb-5">
      <app-need-help [isMonitoringApp]="true"></app-need-help>
    </div>
  </ng-container>
</div>
